import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Form } from 'reactstrap'
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'
import { setDoc, doc } from 'firebase/firestore'
import { toast } from 'react-toastify'

import { auth, db } from '../firebase.config'
import Helmet from '../components/Helmet/Helmet'
import '../styles/signup.css'

const Signup = () => {
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const signup = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const { user } = await createUserWithEmailAndPassword(auth, email, password)
      await updateProfile(user, { displayName: username })
      await setDoc(doc(db, 'users', user.uid), { uid: user.uid, displayName: username, email })
      toast.success('Your account is ready')
      navigate('/login')
    } catch (error) { toast.error(error.message || 'Something went wrong') } finally { setLoading(false) }
  }

  return (
    <Helmet title='Create account'>
      <section className='auth__page'>
        <Container><Row className='align-items-stretch'>
          <Col lg='6' className='auth__intro'><span className='section__eyebrow'>Join Gadget Groove</span><h1>Better tech starts here.</h1><p>Create your account for a faster, more personal shopping experience.</p><div className='auth__benefits'><span><i className='ri-check-line'></i> Checkout with confidence</span><span><i className='ri-check-line'></i> Keep order details together</span><span><i className='ri-check-line'></i> Get help when you need it</span></div></Col>
          <Col lg='6'><div className='auth__card'><h2>Create account</h2><p className='auth__lead'>A few details and you’re ready to go.</p><Form className='auth__form' onSubmit={signup}><label><span>Your name</span><input type='text' placeholder='Full name' value={username} onChange={(e) => setUsername(e.target.value)} required /></label><label><span>Email address</span><input type='email' placeholder='you@example.com' value={email} onChange={(e) => setEmail(e.target.value)} required /></label><label><span>Password</span><input type='password' minLength='6' placeholder='At least 6 characters' value={password} onChange={(e) => setPassword(e.target.value)} required /></label><button type='submit' className='buy__btn auth__btn' disabled={loading}>{loading ? 'Creating account…' : 'Create account'}</button><p className='auth__switch'>Already have an account? <Link to='/login'>Sign in</Link></p></Form></div></Col>
        </Row></Container>
      </section>
    </Helmet>
  )
}

export default Signup
